import { QueryKey } from '@tanstack/react-query';
import { InvitationService } from '../../api';
import { DefaultQueryKeyFactory, QueryKeyFactoryGenerator } from '../../utils/query-keys-factory';

export const invitationQueryKeys = new QueryKeyFactoryGenerator<
  DefaultQueryKeyFactory,
  {
    detailFromToken: (token: string) => QueryKey;
  }
>('invitations', {
  detailFromToken: (token: string): QueryKey => [
    ...invitationQueryKeys.allDetails(),
    'fromToken',
    token,
  ],
}).getDefault<typeof InvitationService.invitationList, string>();
